<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area area_white">
      <div class="tit_area">
        <div class="sub_tit">평가·보상제도</div>
        <div class="sub_txt">
          한국오션플랫폼은 개인의 역량을 반영한<br />공정한 평가 · 보상과
          인재육성을 추구하고 있습니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="recruit02"></div>

    <!-- sub contents -->
    <div class="sub_contents">
      <div class="tbl_ty04 tbl_edu">
        <div class="row">
          <div class="li_con">
            <div class="li_box">
              <strong>평가제도</strong>
              <ul>
                <li>목표 설정 후 성과 측정 및 연말 종합평가 실시</li>
                <li>
                  단위 평가 결과에 다른 등급 및 종합 비율 산정을 통한 임직원
                  평가
                </li>
                <li>평가에 따른 조기 진급제도 운용</li>
              </ul>
            </div>
          </div>
          <div class="li_con">
            <div class="li_box">
              <strong>보상제도</strong>
              <ul>
                <li>개인 평가 기준의 연봉제 운영</li>
                <li>회사 성과에 따른 성과급 제도 운용</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sub_tit_area area_white">
      <div class="tit_area">
        <div class="sub_tit">복리후생</div>
        <div class="sub_txt">
          한국오션플랫폼은 일과 개인의 삶이 균형 잡힐 수 있도록<br />다양한
          복리후생제도를 운영하고 있습니다.
        </div>
      </div>
    </div>
    <div class="recruit02_1"></div>
    <div class="sub_contents">
      <div class="tbl_ty04 tbl_welfare">
        <div class="row">
          <div class="li_con">
            <div class="li_box">
              <strong>자녀 학자금 지원</strong>
              <ul>
                <li>자녀 학자금 (중등/고등/대학교) 전액 지원</li>
                <li>자녀 수 제한 없음</li>
                <li>유치원 학자보조금 지원(만 5세~6세 자녀 대상)</li>
              </ul>
            </div>
          </div>
          <div class="li_con">
            <div class="li_box">
              <strong>경조사 지원</strong>
              <ul>
                <li>본인 및 가족의 결혼, 회갑 등에 경조사비와 화환 지원</li>
                <li>경조 사유 발생 시 경조휴가 부여</li>
                <li>장기근속 포상금 지급</li>
                <li>본인/배우자 출산 축하 선물 지급</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="li_con">
            <div class="li_box">
              <strong>의료비 지원</strong>
              <ul>
                <li>의료비 지원 (본인 90%, 배우자/자녀 50%)</li>
                <li>매년 본인 및 배우자 종합 건강검진 제공</li>
              </ul>
            </div>
          </div>
          <div class="li_con">
            <div class="li_box">
              <strong>교통/통신비 지원</strong>
              <ul>
                <li>교통/통신비 월 정액 지원</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="li_con">
            <div class="li_box">
              <strong>주택자금융자 지원</strong>
              <ul>
                <li>주택 매매/전세 자금 지원</li>
              </ul>
            </div>
          </div>
          <div class="li_con">
            <div class="li_box">
              <strong>자기개발 지원</strong>
              <ul>
                <li>역량개발을 위한 자기개발비 지원</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="li_con">
            <div class="li_box">
              <strong>휴가 및 시설 지원</strong>
              <ul>
                <li>연차휴가 및 하계휴가 (4일)</li>
                <li>하계 휴가비 지원</li>
                <li>
                  소노호텔&리조트, 엘리시안강촌, 보성다비치콘도 연중무휴 이용
                </li>
              </ul>
            </div>
          </div>
          <div class="li_con">
            <div class="li_box">
              <strong>기념품 지급</strong>
              <ul>
                <li>생일, 명절, 창립기념일, 근로자의 날 기념품 지급</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';
export default {
  mixins: [page]
};
</script>

<style lang="scss" scoped></style>
